import { forwardRef } from "react";
import { Link as RouterLink, NavLink as RouterNavLink, LinkProps, NavLinkProps } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

/** Router links that keep the current language prefix on internal paths. */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...rest }, ref) => {
  const { path } = useI18n();
  return <RouterLink ref={ref} to={typeof to === "string" && to.startsWith("/") ? path(to) : to} {...rest} />;
});
Link.displayName = "LocaleLink";

export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(({ to, ...rest }, ref) => {
  const { path } = useI18n();
  return <RouterNavLink ref={ref} to={typeof to === "string" && to.startsWith("/") ? path(to) : to} {...rest} />;
});
NavLink.displayName = "LocaleNavLink";
